<template>
  <v-card class="unselectable ma-0 pa-1" :img="image" elevation="20" dark>
    <v-card-title class="display-3 white--text text-capitalize">{{
      time
    }}</v-card-title>
    <v-card-text class="display-1 white--text font-weight-medium">{{
      text
    }}</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ClassCard",
  props: { text: String, time: String, image: String }
};
</script>

<style scoped>
</style>